import { Component, input } from '@angular/core';

@Component({
  selector: 'app-arrow-icon',
  standalone: true,
  templateUrl: './arrow-icon.component.html',
})
export class ArrowIconComponent {
  color = input<string>('white');
  width = input<string>('5px');
  height = input<string>('5px');
}
